<script setup>
defineProps({
  name: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  checked: {
    type: Boolean,
    default: false,
  }
})
</script>
<template>
  <div class="form-check">
    <input :id="id" class="form-check-input" type="radio" :name="name" :checked="checked" />
    <label class="custom-control-label" :for="id">
      <slot />
    </label>
  </div>
</template>
